<template>
  <div class="earnMoney">
    <div style="display: flex; height: 32px;align-items: center;">
      <div style="line-height: 32px; font-size: 15px; margin-right: 20px">
        统计时间
      </div>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='DAY'?'active':''"
        type="text"
        @click="chooseType('DAY')"
      >今日</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='MONTH'?'active':''"
        type="text"
        @click="chooseType('MONTH')"
      >本月</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='YEAR'?'active':''"
        type="text"
        @click="chooseType('YEAR')"
      >本年</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='ALL'?'active':''"
        type="text"
        @click="chooseType('ALL')"
      >全部</el-button>
      <el-form ref="form" :model="form" inline>
        <el-form-item label="自定义时间">
          <el-date-picker
            v-model="form.date1"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            size="small"
            style="width: 150px;"
          />
          &nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;
          <el-date-picker
            v-model="form.date2"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 150px;"
          />
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="onSubmit">统计</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="font-size: 15px; line-height: 60px; height: 60px; border-bottom: 3px solid rgb(220, 223, 230);">
      电站名称
      <input v-model="stationName" type="text" placeholder="请输入电站名称" style="height: 24px; margin-left: 30px">
    </div>
    <div class="box" style="height: 173px; display: flex; align-items: center; position: relative;">
      <div
        style="
            width: 20%;
            display: flex;
            box-shadow: 4px 4px 3px rgb(204 204 204 / 35%);
          "
        class="shadow"
      >
        <div style="margin-left: 20px">
          <i class="iconfont icon-iconset0216" style="font-size: 94px" />
        </div>
        <div style="margin-top: 10px; margin-left: 30px">
          <div style="font-size: 22px; color: #333333; margin-bottom: 10px">
            充电度数
          </div>
          <span class="moneyNum" :title="detail.power">{{
            getFloat(detail.power)
          }}</span>
          <span style="font-size: 14px; color: #333333">度</span>
        </div>
      </div>
      <div
        style="
            width: 20%;
            display: flex;
            box-shadow: 4px 4px 3px rgb(204 204 204 / 35%);
          "
        class="shadow"
      >
        <div style="margin-left: 20px">
          <img src="./../../assets/icon2.png" alt="" style="width: 100px; height: 97px">
        </div>
        <div style="margin-top: 10px; margin-left: 30px">
          <span
            style="
                font-size: 22px;
                color: #333333;
                margin-bottom: 10px;
                display: block;
              "
          >实收电费</span>
          <span class="moneyNum" :title="detail.elecMoney">{{
            getFixed2(detail.elecMoney)
          }}</span>
          <span style="font-size: 14px; color: #333333">元</span>
        </div>
      </div>
      <div
        style="
            width: 20%;
            display: flex;
            box-shadow: 4px 4px 3px rgb(204 204 204 / 35%);
          "
        class="shadow"
      >
        <div style="margin-left: 20px">
          <img src="./../../assets/icon3.png" alt="" style="width: 100px; height: 97px">
        </div>
        <div style="margin-top: 10px; margin-left: 30px">
          <span
            style="
                font-size: 22px;
                color: #333333;
                margin-bottom: 10px;
                display: block;
              "
          >实收服务费</span>
          <span class="moneyNum" :title="detail.serviceMoney">{{
            getFixed2(detail.serviceMoney)
          }}</span>
          <span style="font-size: 14px; color: #333333">元</span>
        </div>
      </div>
      <div
        style="
            width: 20%;
            display: flex;
            box-shadow: 4px 4px 3px rgb(204 204 204 / 35%);
          "
        class="shadow"
      >
        <div style="margin-left: 20px">
          <img src="./../../assets/icon4.png" alt="" style="width: 100px; height: 97px">
        </div>
        <div style="margin-top: 10px; margin-left: 30px">
          <span
            style="
                font-size: 22px;
                color: #333333;
                margin-bottom: 10px;
                display: block;
              "
          >服务费分润</span>
          <span class="moneyNum" :title="detail.amount">{{
            getFloat(detail.amount)
          }}</span>
          <span style="font-size: 14px; color: #333333">元</span>
        </div>
      </div>
    </div>
    <div class="main" style="position:relative">
      <el-button type="primary" style="position:absolute;right:40px;top:20px" @click="exportOrder">导出</el-button>
      <el-card>
        <el-tabs v-model="activeName" @tab-click="onSubmit">
          <el-tab-pane label="电站" name="station" />
          <el-tab-pane label="订单明细" name="order" />
        </el-tabs>
        <template v-if="activeName == 'station'">
          <el-table :data="tableData" stripe border style="width: 100%">
            <el-table-column type="index" align="center" width="50" label="序号" />
            <el-table-column label="电站名称" align="center">
              <template slot-scope="scope">
                {{ scope.row.stationName }}
              </template>
            </el-table-column>
            <el-table-column label="归属运营商" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.orgName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电度数" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.power) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收电费" align="center">
              <template slot-scope="scope">
                <span>{{ getFixed2(scope.row.elecMoney) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收服务费" align="center">
              <template slot-scope="scope">
                <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="分润模式" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.mode=='PERCENT'?'固定折扣':'固定价格' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="分润金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.amount) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="activeName == 'order'">
          <el-table :data="tableData" stripe border style="width: 100%">
            <el-table-column type="index" align="center" width="50" label="序号" />
            <el-table-column label="充电单号" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="goToDetail(scope.row)">{{ scope.row.startChargeSeq }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="电站名称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.stationName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电枪编码" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.connectorID }}</span>
              </template>
            </el-table-column>
            <el-table-column label="用户归属企业" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.accountOrgName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="支付时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.payTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电度数" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.power) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收电费" align="center">
              <template slot-scope="scope">
                <span> {{ getFixed2(scope.row.elecMoney) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收服务费" align="center">
              <template slot-scope="scope">
                <span> {{ getFixed2(scope.row.serviceMoney) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="分润模式" align="center">
              <template slot-scope="scope">
                <span> {{ scope.row.mode=='PERCENT'?'固定折扣':'固定价格' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="分润金额" align="center">
              <template slot-scope="scope">
                <span> {{ getFloat(scope.row.amount) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-card>
    </div>
    <el-pagination
      v-if="pageshow"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'Fenrunhuizong',
  components: {},
  data() {
    return {
      stationName: '',
      form: {
        date1: '',
        date2: ''
      },
      timeType: 'DAY',
      activeName: 'station',
      detail: {},
      tableData: [],
      currentPage: 1, // 当前页
      total: 0, // 总页数
      pagesize: 10, // 每页条数
      pageshow: true
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getPageData()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    reset() {
      this.stationName = ''
      this.form = {
        date1: '',
        date2: ''
      },
      this.timeType = 'DAY'
      this.getPageData()
    },
    chooseType(val) {
      this.timeType = val
      this.form = {
        date1: '',
        date2: ''
      }
    },
    onSubmit() {
      this.getPageData()
    },
    handleSizeChange(val) {
      this.pageshow = false
      this.pagesize = val
      this.getPageData()
    },
    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.getPageData()
    },
    getPageData(val) {
      const data = {
        stationName: this.stationName,
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2
      }
      let url = '/finance/profit/view/station'
      if (this.activeName === 'order') {
        url = '/finance/profit/view/order'
      }
      this.$store.dispatch('form/handle', {
        url: url,
        data: data,
        method: 'get',
        callback: (resp) => {
          this.detail = resp.summary
          if (resp.list && resp.list.length > 0) {
            this.tableData = resp.list
            this.pageshow = true
          } else {
            this.pageshow = false
            this.tableData = []
          }
          this.currentPage = resp.pageNo
          this.total = resp.count
          this.pagesize = resp.pageSize
        }
      })
    },
    exportOrder() {
      let url = HOST + '/finance/profit/view/station/export'
      if (this.activeName === 'order') {
        url = HOST + '/finance/profit/view/order/export'
      }
      $.fileDownload(url, {
        httpMethod: 'get',
        data: {
          stationName: this.stationName,
          pageNo: this.currentPage,
          pageSize: this.pagesize,
          timeType: this.timeType,
          startTime: this.form.date1,
          endTime: this.form.date2,
          token: window.localStorage.getItem('token')
        },
        failCallback: (html, url) => {
          this.$notify({
            title: '失败',
            message: '导出失败',
            type: 'error'
          })
        }
      })
    },
    goToDetail(item) {
      this.$router.push({ path: '/orderManagement/historyDetail', query: { data: item.orderId, num: item.startChargeSeq }})
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" scoped>
    .earnMoney {
        .textType {
            color: #C0C4CC;
            width: 100px;

            &.active {
                color: #409eff;
                border-bottom: 2px solid #409eff;
            }
        }
        .shadow {
            box-sizing: border-box;
            border-width: 1px;
            border-style: solid;
            border-color: rgba(233, 233, 233, 1);
            border-radius: 2px;
            padding: 20px 0;
        }

        .box {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            margin-bottom: 20px;
            padding: 0 20px;

            .moneyNum {
                font-size: 31px;
                color: #1890ff;
                font-weight: 500;
                max-width: calc(100% - 20px);
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            div {
                .iconfont {
                    font-size: 28px;
                    font-weight: 600;
                }

                .icon-iconset0216 {
                    color: #32f83e;
                }

                .icon-lirunbiao {
                    color: #f2e743;
                }

                .icon-yingshouzhangkuan {
                    color: #f2e743;
                    font-size: 24px;
                }

                .icon-qianbao {
                    color: #409eff;
                }

                .icon-qianbao1 {
                    color: #409eff;
                    font-size: 24px;
                }

                .icon-yingshouzhangkuan {
                    font-size: 26px;
                }

                .icon-shishoufeiyong {
                    font-size: 30px;
                }
            }
        }

        .el-form {
            .el-form-item {
                margin-bottom: 0 !important;
            }

            display: flex !important;

            .el-input__prefix {
                line-height: 32px !important;
            }

            .el-form-item__content {
                margin-left: 0 !important;
                line-height: 32px !important;
            }

            .el-date-editor {
                width: 220px !important;
            }

            .el-col-2 {
                width: 30px;
                text-align: center;
                line-height: 32px;
            }

            .el-col-11 {
                width: 220px !important;
                line-height: 32px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/earnMoney.vue